import { useEffect, useRef } from "react";
import "@/App.css";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n";
import { LenisContext } from "@/lenis-context";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Story from "@/components/Story";
import Team from "@/components/Team";
import Establishments from "@/components/Establishments";
import Press from "@/components/Press";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (target) => lenisRef.current?.scrollTo(target, { offset: -72 });

  return (
    <LanguageProvider>
      <LenisContext.Provider value={scrollTo}>
        <div className="grain bg-paper font-sans text-pine antialiased">
          <Header />
          <main>
            <Hero />
            <Story />
            <Team />
            <Establishments />
            <Press />
            <Contact />
          </main>
          <Footer />
        </div>
      </LenisContext.Provider>
    </LanguageProvider>
  );
}

export default App;
